import { Button } from 'antd';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { MessageBanner } from 'client/ui/message-banner/MessageBanner';
import { UserSource } from 'common/schema/User';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Banner che avverte l'utente che è necessario l'update della nazionalità.
 *
 * (Inserito per l'obbligo per gli utenti EU di passare ad un utente loggato con trustedSSO)
 */
export function UserNationalityUpdateBanner() {
  const user = useCurrentUser();
  const { t } = useTranslation();

  // Gli utenti registrati via mail che non hanno ancora
  // aggiornato la loro nazionalità vedranno il banner
  if (
    !user ||
    user.source !== UserSource.EmailRegistration ||
    (user.source === UserSource.EmailRegistration &&
      user.citizen?.nationality != null)
  ) {
    return null;
  }

  return (
    <MessageBanner>
      <div style={{ textAlign: 'center' }}>
        {t(
          'user.nationality.banner-text',
          `Il tuo profilo è incompleto. È necessario aggiornare il profilo indicando la propria nazionalità per poter inviare nuove istanze. Per i cittadini dell'Unione Europea è obbligatorio effettuare l'accesso tramite le credenziali SPID / eIDAS / CIE.`
        )}{' '}
        <Link to="/utente/profilo">
          <Button
            size="small"
            children={t('user.button.text.profile', 'Modifica Profilo')}
          />
        </Link>
      </div>
    </MessageBanner>
  );
}
